import React from "react";
import "./PhotoUpload.scss";

/**
 * PhotoUpload
 * ─────────────────────────────────────────────────────────────────────────────
 * Dashed upload box with preview, "Change Photo" and "Remove" buttons.
 * Mirrors the photo-upload-box pattern used in every person-profile modal.
 *
 * Props:
 *   value     {string}   - Preview URL (object URL or remote URL)
 *   onChange  {Function} - (e) => void — file input onChange
 *   onRemove  {Function} - () => void
 *   inputId   {string}   - Unique id for the hidden <input type="file">
 *   shape     {"circle" | "square"} — default "circle"
 */
const PhotoUpload = ({
  value,
  onChange,
  onRemove,
  inputId = "shPhotoUpload",
  shape = "circle",
}) => {
  return (
    <div className="sh-photo-upload-box">
      {value ? (
        <div className="sh-photo-preview-block">
          <img
            src={value}
            alt="Profile"
            className={`sh-photo-preview sh-photo-preview--${shape}`}
          />
          <div className="sh-photo-preview-actions">
            <label className="sh-photo-action-btn" htmlFor={inputId}>
              Change Photo
            </label>
            <button
              type="button"
              className="sh-photo-action-btn"
              onClick={onRemove}
            >
              Remove
            </button>
          </div>
        </div>
      ) : (
        <label className="sh-upload-placeholder" htmlFor={inputId}>
          <svg
            viewBox="0 0 24 24"
            width="32"
            height="32"
            fill="none"
            stroke="#9ca3af"
            strokeWidth="1.5"
          >
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          <span>Click to upload photo</span>
          <small>JPG, PNG, WEBP supported</small>
        </label>
      )}
      <input
        id={inputId}
        type="file"
        accept="image/*"
        onChange={onChange}
        className="sh-photo-file-input"
      />
    </div>
  );
};

export default PhotoUpload;
